module.exports = "/static-assets/_next/static/images/button-grain-a7b0c75838ad621555b7b4a5dfb566dc.png";